import { onSnapshot, Query, QuerySnapshot } from "firebase/firestore";
import { Atom, atom } from "jotai";
import { SnapshotResult } from "./types";

export type QueryResultAtom<T> = Atom<SnapshotResult<T[], QuerySnapshot>>;

const cache = new Map<string, QueryResultAtom<unknown>>();

export function observeFirestoreQueryAtom<T>(
  query: Query,
  queryId?: string,
): QueryResultAtom<T> {
  if (queryId && cache.has(queryId)) {
    return cache.get(queryId)! as QueryResultAtom<T>;
  }

  const dataAtom = atom<SnapshotResult<T[], QuerySnapshot>>({
    data: undefined,
    loading: true,
    error: undefined,
    snapshot: undefined,
  });

  dataAtom.onMount = (dispatch) => {
    return onSnapshot(
      query,
      (snapshot) => {
        dispatch({
          data: snapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data() } as T;
          }),
          loading: false,
          error: undefined,
          snapshot: snapshot,
        });
      },
      (error) => {
        dispatch({
          data: undefined,
          loading: false,
          error: error,
          snapshot: undefined,
        });
      },
    );
  };

  if (queryId) cache.set(queryId!, dataAtom as QueryResultAtom<unknown>);

  return atom((get) => {
    return get(dataAtom);
  });
}
